<template>
    <div>
        <b-table hover :items="getArrayData" v-bind:thead-class="{'d-none': isChild}">
            <template #cell(fieldName)="data">
                <b>{{data.value}}: </b>
            </template>

            <template #cell(value)="data">
                <div v-if="typeof data.value === 'object' && data.value !== null">
                    <JsonPrettyTable
                            :jsonData="data.value"
                            :isChild="true"
                    />
                </div>
                <div v-else v-html="data.value"></div>
            </template>
        </b-table>
    </div>
</template>

<script>
    import { upperFirst, startCase, toLower, isArray, isObject } from 'lodash';
    export default {
        name: 'JsonPrettyTable',
        props: {
            jsonData: {
                type: Object
            },
            isChild: {
                type: Boolean
            }
        },
        computed: {
            getArrayData() {
                if( !isObject(this.jsonData) ) {
                    return [];
                }

                return Object.entries(this.jsonData).map((arr) => ({
                    fieldName: this.normalizeTitle(arr[0]),
                    value: isArray(arr[1]) ? arr[1].join(',') : arr[1],
                }));
            },
        },
        methods: {
            normalizeTitle: (title) => {
                return upperFirst(toLower(startCase(title)));
            }
        }
    }
</script>